/** Países suportados no seletor de telefone (DDI + máscara nacional). */
export const PHONE_COUNTRIES = [
  { iso: "BR", dial: "55", name: "Brasil", nationalMax: 11, placeholder: "(00) 00000-0000" },
  { iso: "AO", dial: "244", name: "Angola", nationalMax: 9, placeholder: "923 456 789" },
  { iso: "PT", dial: "351", name: "Portugal", nationalMax: 9, placeholder: "912 345 678" },
  { iso: "ES", dial: "34", name: "Espanha", nationalMax: 9, placeholder: "612 345 678" },
  { iso: "MZ", dial: "258", name: "Moçambique", nationalMax: 9, placeholder: "84 123 4567" },
  { iso: "CV", dial: "238", name: "Cabo Verde", nationalMax: 7, placeholder: "991 23 45" },
  { iso: "US", dial: "1", name: "EUA/Canadá", nationalMax: 10, placeholder: "(555) 123-4567" },
  { iso: "AR", dial: "54", name: "Argentina", nationalMax: 10, placeholder: "11 2345-6789" },
  { iso: "PY", dial: "595", name: "Paraguai", nationalMax: 9, placeholder: "981 123456" },
  { iso: "UY", dial: "598", name: "Uruguai", nationalMax: 8, placeholder: "94 123 456" },
  { iso: "CL", dial: "56", name: "Chile", nationalMax: 9, placeholder: "9 1234 5678" },
  { iso: "CO", dial: "57", name: "Colômbia", nationalMax: 10, placeholder: "300 123 4567" },
  { iso: "MX", dial: "52", name: "México", nationalMax: 10, placeholder: "55 1234 5678" },
  { iso: "OTHER", dial: "", name: "Outro (DDI+número)", nationalMax: 15, placeholder: "DDI + número" },
];

/** URL da bandeira (flagcdn). OTHER = ONU/globo genérico. */
export function flagUrl(iso, width = 40) {
  if (!iso || iso === "OTHER") {
    return `https://flagcdn.com/w${width}/un.png`;
  }
  return `https://flagcdn.com/w${width}/${String(iso).toLowerCase()}.png`;
}

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

/** Espelha utils.ToWhatsAppNumber do Go. */
export function toWhatsAppNumber(phone) {
  const d = digitsOnly(phone);
  if (!d) return "";
  if (d.startsWith("55") && d.length >= 12 && d.length <= 13) return d;
  if (d.length === 10 || d.length === 11) return `55${d}`;
  if (d.length >= 12) return d;
  return `55${d}`;
}

export function toWhatsAppUrl(phone, text) {
  const n = toWhatsAppNumber(phone);
  if (!n) return null;
  const base = `https://wa.me/${n}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

/** Formatação de exibição (BR nacional ou internacional com DDI). */
export function getTelephone(value) {
  const d = digitsOnly(value);
  if (!d) return "-";

  // BR legado (10/11) ou BR com 55
  if (d.length === 10 || d.length === 11) {
    return d.replace(/(\d{2})(\d)(\d{4})(\d{4})/, "+55 ($1) $2$3-$4");
  }
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) {
    const n = d.slice(2);
    return n.replace(/(\d{2})(\d)(\d{4})(\d{4})/, "+55 ($1) $2$3-$4");
  }

  const parsed = parseStoredPhone(d);
  if (parsed.iso !== "OTHER" && parsed.dial && parsed.national) {
    const national = formatNationalDisplay(parsed.iso, parsed.national);
    return `+${parsed.dial} ${national}`.trim();
  }

  return `+${d}`;
}

export function formatNationalDisplay(iso, nationalDigits) {
  const d = digitsOnly(nationalDigits);
  if (iso === "BR") {
    if (d.length > 10) return d.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, "($1) $2-$3").trim();
    if (d.length > 6) return d.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, "($1) $2-$3").trim();
    if (d.length > 2) return d.replace(/^(\d{2})(\d{0,5})/, "($1) $2").trim();
    if (d.length > 0) return `(${d}`;
    return "";
  }
  return d.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
}

export function parseStoredPhone(stored) {
  const d = digitsOnly(stored);
  if (!d) return { iso: "BR", dial: "55", national: "" };
  if (d.length === 10 || d.length === 11) {
    return { iso: "BR", dial: "55", national: d };
  }
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) {
    return { iso: "BR", dial: "55", national: d.slice(2) };
  }
  const sorted = [...PHONE_COUNTRIES]
    .filter((c) => c.iso !== "OTHER" && c.dial)
    .sort((a, b) => b.dial.length - a.dial.length);
  for (const c of sorted) {
    if (d.startsWith(c.dial) && d.length > c.dial.length) {
      const national = d.slice(c.dial.length);
      if (national.length <= c.nationalMax + 2) {
        return { iso: c.iso, dial: c.dial, national };
      }
    }
  }
  return { iso: "OTHER", dial: "", national: d };
}

export function buildStoredPhone(iso, dial, nationalDigits) {
  const national = digitsOnly(nationalDigits);
  if (!national) return "";
  if (iso === "BR") return national;
  if (iso === "OTHER" || !dial) return national;
  return `${dial}${national}`;
}

export function isPhoneComplete(iso, dial, nationalDigits) {
  const national = digitsOnly(nationalDigits);
  const country = PHONE_COUNTRIES.find((c) => c.iso === iso) || PHONE_COUNTRIES[0];
  if (iso === "BR") return national.length === 10 || national.length === 11;
  if (iso === "OTHER") return national.length >= 10;
  const min = Math.max(6, country.nationalMax - 2);
  return national.length >= min && national.length <= country.nationalMax;
}
